export default "__VITE_PUBLIC_ASSET__47fc6c8e__"